import { setPreferredTheme } from "@/redux/meta/metaActions";
import { ThemePreference } from "@/types/Theme";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import {useLocation} from "react-router";

// Define the routes where the theme should not be active
const themeExcludedRoutes: string[] = [
    "/brands",
];

const useThemePreference = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    // Force dark mode for all users - ignore stored preferences
    const isOnDarkMode = useMemo(() => {
        if (themeExcludedRoutes.find(route => location.pathname.includes(route))) {
            return false;
        }

        // Always return true (dark mode) regardless of user preference
        return true;
    }, [location.pathname]);

    /**
     * Returns the themed image url based on the current theme.
     * @param imageUrl
     */
    const getThemedImageUrl = (imageUrl: string) => {
        const lastSlashIndex = imageUrl.lastIndexOf("/");
        if (lastSlashIndex !== -1) {
            const base = imageUrl.substring(0, lastSlashIndex + 1);
            const fileName = imageUrl.substring(lastSlashIndex + 1);
            const themedFileName = `${isOnDarkMode
                ? "DM-"
                : ""}${fileName}`;
            return base + themedFileName;
        }
        return imageUrl;
    };

    /**
     * Applies the specified theme and saves it to the redux store.
     * If the specified theme is automatic, it will use the browser's
     * pefers-color-scheme to determine the theme.
     * @param theme
     */
    const setTheme = (_theme: ThemePreference, persistOnStore = true) => {
        // Always force dark mode regardless of input
        const newTheme = ThemePreference.DARK;
        document.documentElement.setAttribute("data-theme", newTheme);
        if (persistOnStore) {
            dispatch(setPreferredTheme(ThemePreference.DARK));
        }
    };
    return {setTheme,
        isOnDarkMode,

        /**
         * Returns the themed image url based on the current theme.
         * @param imageUrl
         */
        getThemedImageUrl};

};

export default useThemePreference;